import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgSpinner(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 3.2C13.4684 3.2 10.9937 3.95071 8.88871 5.35719C6.78376 6.76367 5.14315 8.76276 4.17435 11.1016C3.20555 13.4405 2.95206 16.0142 3.44596 18.4971C3.93985 20.9801 5.15893 23.2608 6.94904 25.051C8.73915 26.8411 11.0199 28.0602 13.5028 28.554C15.9858 29.0479 18.5595 28.7945 20.8984 27.8256C23.2372 26.8568 25.2363 25.2162 26.6428 23.1113C28.0493 21.0063 28.8 18.5316 28.8 16H32C32 19.1645 31.0616 22.2579 29.3035 24.8891C27.5454 27.5203 25.0466 29.5711 22.1229 30.7821C19.1993 31.9931 15.9823 32.3099 12.8786 31.6926C9.77486 31.0752 6.92394 29.5513 4.6863 27.3137C2.44866 25.0761 0.924806 22.2251 0.307443 19.1214C-0.309921 16.0177 0.00693261 12.8007 1.21793 9.87706C2.42894 6.95344 4.4797 4.45459 7.11088 2.69649C9.74207 0.938384 12.8355 0 16 0V3.2Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSpinner);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
